import {CONFIRM_OPERATION_OPEN, CONFIRM_OPERATION_CLOSE} from '../../actions/Constants';

const INITIAL_STATE = { open: false, description: null, onSuccess: null };

export default function confirmOperation(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CONFIRM_OPERATION_OPEN:
      return {
        ...state,
        open: true,
        description: action.payload.description,
        onSuccess: action.payload.onSuccess,
      };
    case CONFIRM_OPERATION_CLOSE:
    return {
      ...state,
      open: false,
      description: null,
      onSuccess: null,
    };

    // initial state
    default:
      return state;
  }
}
